import React from "react";
const AccountContext = React.createContext({
    account: null,
    accountLoading: true,
    accountError: false,
    refetchAccount: null
});
export default AccountContext;